/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.35.0 */
import "./render-ellipsis.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box, Text } from '@atlaskit/primitives/compiled';
import VisuallyHidden from '@atlaskit/visually-hidden';
var styles = {
  container: "_1e0c1txw _kqswh2mm"
};
export default function renderEllipsis(_ref) {
  var key = _ref.key,
    testId = _ref.testId,
    from = _ref.from,
    to = _ref.to;
  return /*#__PURE__*/React.createElement(Box, {
    as: "li",
    testId: testId,
    key: key,
    xcss: styles.container,
    paddingInline: "space.100"
  }, /*#__PURE__*/React.createElement(Text, {
    testId: testId && "".concat(testId, "-text")
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, "Skipped pages from ", from, " to ", to), "\u2026"));
}